import PropTypes from "prop-types";
import {Avatar, Card, CardContent, Stack, SvgIcon, Typography} from "@mui/material";
import {AirportShuttle} from "@mui/icons-material";

export const OverviewThisWeekDeliveries = (props) => {
    const {sx, value} = props;

    return (
        <Card sx={sx}>
            <CardContent>
                <Stack
                    alignItems="flex-start"
                    direction="row"
                    justifyContent="space-between"
                    spacing={3}
                >
                    <Stack spacing={1}>
                        <Typography color="text.secondary" variant="overline">
                            This week deliveries
                        </Typography>
                        <Typography variant="h5">{value}</Typography>
                    </Stack>
                    <Avatar
                        sx={{
                            backgroundColor: "success.main",
                            height: 56,
                            width: 56,
                        }}
                    >
                        <SvgIcon>
                            <AirportShuttle/>
                        </SvgIcon>
                    </Avatar>
                </Stack>
            </CardContent>
        </Card>
    );
};

OverviewThisWeekDeliveries.propTypes = {
    difference: PropTypes.number,
    positive: PropTypes.bool,
    value: PropTypes.string.isRequired,
    sx: PropTypes.object,
};
